import React from 'react';
import SamuraiGame from '../SamuraiGame';

const ThreeByTwo = () => {
    return <SamuraiGame initialDrillIndex={0} />;
};

export default ThreeByTwo;
